import { EmploymentEmployerRes } from '@dealstack/shared/lib/generated';
import {
	DATE_FORMATS,
	formatDateToUI,
	parseBEDateIgnoreTimezone,
} from '@dealstack/shared/lib/format/dates/date';

export const formatEmploymentDate = (value?: string | null): string | undefined =>
	value ? formatDateToUI(parseBEDateIgnoreTimezone(value), DATE_FORMATS.UI_SHORT) : undefined;

/** Records reference their employer by id only; names come from the deal's employer list. */
export const getEmployerNameById = (
	employers: EmploymentEmployerRes[],
	employerId: string
): string | undefined => employers.find((employer) => employer.id === employerId)?.displayName;
